export class DownloadCsvController {
    private district: string;
    private school: string;
    private status: string;
    private importType: string;
    private linkText: string;

    /* @ngInject */
    constructor(private ORIGIN: string) {
    }

    getCsvDownloadPath() {
        if (!this.school) {
            return `${this.ORIGIN}/clever-${this.importType}-match/district/${this.district}/${this.status}-district`;
        } else {
            return `${this.ORIGIN}/clever-${this.importType}-match/district/${this.district}/${this.school}/${this.status}`;
        }
    }

    getLinkText() {
        return this.linkText ? this.linkText : "download CSV";
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/download-csv/download-csv.controller.ts